/**
 * @fileoverview DELETE handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id" endpoint.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteDecisioningStudioAgentsBaseCreativeCacheKeys } from "./constants";
import type {
  DeleteDecisioningStudioAgentsBaseCreativeProps,
  DeleteDecisioningStudioAgentsBaseCreativeResult,
} from "./types";

export const deleteDecisioningStudioAgentsBaseCreative = reactQueryMutationAdapter(
  deleteDecisioningStudioAgentsBaseCreativeCacheKeys,
  ({
    appGroupId,
    campaignId,
    dsaId,
    writeMode,
  }: DeleteDecisioningStudioAgentsBaseCreativeProps): Promise<DeleteDecisioningStudioAgentsBaseCreativeResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/base_creatives/${campaignId}`,
      "DELETE",
      writeMode !== undefined ? { write_mode: writeMode } : {},
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
